import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { AppRoutes } from '../../../../../../constants/appRoutes';
import { Roles } from '../../../../../../constants/roles';
import { RegionTypes } from '../../../../../../config/regions';
import { buildLocalizeRoute } from '../../../../../../helpers/languageHelper';
import { Observables } from '../../../../../../observables';
import { useTranslation } from 'react-i18next';
import { LanguageService } from '../../../../../../services/languageService';
import Logo from '../../../../../components/common/logo';
import AccountPopover from './components/accountPopover';
import LanguagePopover from './components/languagePopover';
import NotificationsPopover from './components/notificationPopover';
import { getUser } from '../../../../../../services/authService';

const APPBAR_MOBILE = 80;
const APPBAR_DESKTOP = 80;

const RootStyle = styled(AppBar)(() => ({
	boxShadow: 'none !important',
	backdropFilter: 'none !important',
	backgroundColor: '#ffffff !important',
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
	minHeight: APPBAR_MOBILE,
	[theme.breakpoints.up('lg')]: {
		minHeight: APPBAR_DESKTOP,
		padding: 0,
	},
	[theme.breakpoints.up('md')]: {
		paddingLeft: '72px',
		paddingRight: '72px',
	},
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
	onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
	// const { t } = useTranslation();
	const languageService = new LanguageService();
	const { t } = useTranslation();
	const user = getUser();
	const isInvestor = user?.role === Roles.Investor;

	// const [isShowPopup, setIsShowPopup] = useState(false);
	// const [investMode, setInvestMode] = useState(null);
	// const investorService = new InvestorService();

	// useEffect(() => {
	// 	setIsShowPopup(DateHelper.dateIsAfter(autoInvestmentPopupClosingDate()));
	// 	investorService
	// 		.getAutoInvestingMode()
	// 		.then((resp) => {
	// 			setInvestMode(resp.data);
	// 		})
	// 		.catch((err) => { });
	// }, []);

	// const autoInvestmentPopupClosingDate = () => {
	// 	return localStorage.getItem('autoInvestPopupClosingTime')
	// 		? localStorage.getItem('autoInvestPopupClosingTime')
	// 		: null;
	// };

	// const onDismissPopup = () => {
	// 	localStorage.setItem(
	// 		'autoInvestPopupClosingTime',
	// 		DateHelper.formatDate(new Date(), 'yyyy-MM-dd')
	// 	);
	// 	setIsShowPopup(false);
	// };

	const isAr = () => languageService.isArabic();

	const currentRegion = localStorage.getItem('region');
	const isUae = currentRegion === RegionTypes.Global; // `ae`
	const targetRegion = isUae ? RegionTypes.SaudiArabia : RegionTypes.Global;

	const onSwitchPlatform = () => {
		if (!targetRegion) return;

		// Keep existing auth tokens for both platforms; just redirect the user
		// to the target platform login page with a returnUrl to the dashboard.
		localStorage.setItem('region', targetRegion);
		const returnUrl = encodeURIComponent(AppRoutes.Investor);
		const loginUrl = buildLocalizeRoute(
			`${AppRoutes.Login}?returnUrl=${returnUrl}`,
			targetRegion,
			false,
			languageService.getCurrentLanguage()
		);
		window.location.replace(loginUrl);
	};

	// const autoInvestBanner = () => {
	// 	return (
	// 		<Box
	// 			className={`absolute h-8 !text-[#343434] bg-white z-[99999]  w-full flex justify-center items-center auto-invest-banner ${investMode === 'Manual' && isShowPopup ? 'show' : ''
	// 				}`}>
	// 			<span className="!text-sm !font-[500] p-2">
	// 				<span>{t('autoActivatePopupContent')}</span>
	// 				<a
	// 					className="underline-link mx-1"
	// 					href={buildLocalizeRoute(
	// 						`${AppRoutes.Investor}/${AppRoutes.InvestmentSettings}`
	// 					)}>
	// 					{t('here')}
	// 				</a>
	// 			</span>
	// 			<Box
	// 				className={`cursor-pointer p-2 md:absolute ${languageService.isArabic() ? '!left-3' : '!right-3'
	// 					}`}>
	// 				<CloseIcon
	// 					onClick={() => {
	// 						onDismissPopup();
	// 					}}
	// 					className="!text-[18px]"></CloseIcon>
	// 			</Box>
	// 		</Box>
	// 	);
	// };

	return (
		<Box className="flex flex-col">
			<RootStyle>
				<Box className="bg-white flex">
					<ToolbarStyle className="w-full">
						<Box>
							<Logo
								url={buildLocalizeRoute(`${AppRoutes.Investor}`)}
								classList={`${isAr() ? 'md:!-ml-[26px] md:!-mr-[26px]' : ''} -ml-[12px] -mr-[12px] md:!w-[150px] !w-[100px]`}
								sx={{ height: 'auto' }}></Logo>
						</Box>
						<Stack
							width="100%"
							direction="row"
							alignItems="center"
							justifyContent="flex-end"
							spacing={1}>
							<LanguagePopover />
							<NotificationsPopover />
							{isInvestor && (currentRegion === RegionTypes.Global || currentRegion === RegionTypes.SaudiArabia) ? (
								<Box
									onClick={onSwitchPlatform}
									onKeyDown={(e) => {
										if (e.key === 'Enter' || e.key === ' ') onSwitchPlatform();
									}}
									role="button"
									tabIndex={0}
									className="flex items-center justify-center border border-gray-300 rounded-full px-3 py-1.5 cursor-pointer hover:bg-gray-50 transition-colors !hidden md:!flex">
									<span className="text-gray-700 !text-sm !font-medium">
										{isUae ? t('switchToKsaPlatform') : t('switchToUaePlatform')}
									</span>
								</Box>
							) : null}
							<Box className="!hidden md:!block">
								<AccountPopover />
							</Box>
							<IconButton
								className="md:!hidden !block !-mt-[5px]"
								onClick={() => {
									Observables.investorSummaryRefresh.next(1);
									onOpenSidebar();
								}}
								sx={{ color: '#333' }}>
								<MenuOutlinedIcon className="!text-[28px]" />
							</IconButton>
						</Stack>
					</ToolbarStyle>
				</Box>
			</RootStyle>
		</Box>
	);
}
